export var TransportStatus;
(function (TransportStatus) {
    TransportStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    TransportStatus["CONNECTING"] = "CONNECTING";
    TransportStatus["CONNECTED"] = "CONNECTED";
})(TransportStatus || (TransportStatus = {}));
//# sourceMappingURL=TransportStatus.js.map